import React from "react";

/**
 * Imej poster responsif: WebP dengan fallback JPEG.
 * size: "tiny" (320w) | "thumb" (640w) | "full" (1600w)
 */
export default function PosterImage({
  poster,
  size = "thumb",
  eager = false,
  className = "",
  testId,
}) {
  const map = {
    tiny: { webp: poster.tinyWebp, jpg: poster.tiny, w: 320, h: 400 },
    thumb: { webp: poster.thumbWebp, jpg: poster.thumb, w: 640, h: 800 },
    full: { webp: poster.srcWebp, jpg: poster.src, w: 1600, h: 2000 },
  };
  const s = map[size] || map.thumb;

  const srcSet =
    size === "thumb"
      ? `${poster.tinyWebp} 320w, ${poster.thumbWebp} 640w`
      : undefined;

  return (
    <picture>
      <source
        type="image/webp"
        srcSet={srcSet || s.webp}
        sizes={srcSet ? "(max-width: 640px) 76vw, (max-width: 1024px) 330px, 430px" : undefined}
      />
      <img
        src={s.jpg}
        alt={poster.alt}
        width={s.w}
        height={s.h}
        className={className}
        loading={eager ? "eager" : "lazy"}
        decoding={eager ? "sync" : "async"}
        fetchPriority={eager ? "high" : "auto"}
        data-testid={testId}
      />
    </picture>
  );
}
